// All the demo data that used as fallbacks when there's nothing in the dataset yet

export const title = 'Blog.'

export const description = [
  {
    _key: '9f1a629887fd',
    _type: 'block',
    children: [
      {
        _key: '4a58edd077880',
        _type: 'span',
        marks: [],
        text: 'A statically generated blog example using ',
      },
      {
        _key: '4a58edd077881',
        _type: 'span',
        marks: ['ec5b66c9b1e0'],
        text: 'Next.js',
      },
      {
        _key: '4a58edd077882',
        _type: 'span',
        marks: [],
        text: ' and ',
      },
      {
        _key: '4a58edd077883',
        _type: 'span',
        marks: ['1f8991913ea8'],
        text: 'Sanity',
      },
      {
        _key: '4a58edd077884',
        _type: 'span',
        marks: [],
        text: '.',
      },
    ],
    markDefs: [
      {
        _key: 'ec5b66c9b1e0',
        _type: 'link',
        href: 'https://nextjs.org/',
      },
      {
        _key: '1f8991913ea8',
        _type: 'link',
        href: 'https://sanity.io/',
      },
    ],
    style: 'normal',
  },
]

export const ogImageTitle = 'A Next.js Blog with a Native Authoring Experience'
